// Breadcrumb ที่แสดงบนหน้า (semantic <nav><ol>) — เข้าคู่กับ JSON-LD BreadcrumbList
// items: [{label, path?}] · ตัวสุดท้าย = หน้าปัจจุบัน (ไม่มีลิงก์)
export default function Breadcrumb({ items, nav }) {
  return (
    <nav className="wrap crumb" aria-label="breadcrumb">
      <ol>
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i}>
              {!last && it.path ? (
                <a href={it.path} onClick={(e) => { e.preventDefault(); nav(it.path); }}>{it.label}</a>
              ) : (
                <span aria-current={last ? 'page' : undefined}>{it.label}</span>
              )}
              {!last && <span className="sep">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
